export default class CardHeaderUtils {
    static getMenuList = (currentPage, miniApp, slug) => {
        const basicMenuList = [
            {
                label: "Editar",
                showLink: !CardHeaderUtils.isCurrentPage(currentPage, "Editar"),
                path: `/applications/${slug}/configurations`
            },
            {
                label: "Versões",
                showLink:
                    !CardHeaderUtils.isCurrentPage(currentPage, "Versões") &&
                    miniApp.revisions &&
                    miniApp.revisions.length > 0,
                path: `/eitri-app-management/eitri-apps/${miniApp.id}/revisions`
            }
        ];

        return basicMenuList;
    };

    static getUserMenuList = (currentPage, email) => {
        return [
            {
                label: "Informações do usuário",
                showLink: !CardHeaderUtils.isCurrentPage(
                    currentPage,
                    "UserDetails"
                ),
                path: `/applications/user/${email}/details`
            },
            {
                label: "Trocar senha",
                showLink: !CardHeaderUtils.isCurrentPage(
                    currentPage,
                    "CreateUserPassword"
                ),
                path: `/applications/user/${email}/reset_user_password`
            }
        ];
    };

    static getSettingsMenuList = currentPage => {
        return [
            {
                label: "Trocar senha",
                showLink: !CardHeaderUtils.isCurrentPage(
                    currentPage,
                    "UserChangePassword"
                ),
                path: "/settings/reset-password"
            },
            {
                label: "Credenciais",
                showLink: !CardHeaderUtils.isCurrentPage(
                    currentPage,
                    "ManagerUserCredentials"
                ),
                path: "/settings/manager-credential"
            }
        ];
    };

    static isCurrentPage = (currentPage, page) => {
        return currentPage === page;
    };
}
